import { render } from "./CookieConsent.vue?vue&type=template&id=3feba74c"
import script from "./CookieConsent.vue?vue&type=script&lang=js"
export * from "./CookieConsent.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./CookieConsent.vue?vue&type=style&index=0&id=3feba74c&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__